const state = {
  uiOptions: {
    pin: false
  },
  options: {
    oid: null,
    hospitalized: 1,
    status: null,
    attention: false,
    order: 'DESC,ASC',
    sort: 'updateTime,state',
    sectionName: 'updateTime'
  },
  recordListOptions: {
    hospitalized: 1,
    startAge: null,
    endAge: null,
    start: null,
    end: null,
    status: null,
    oids: null,
    patient: null,
    historySn: null,
    isImage: null,
    attention: null,
    tags: null,
    sectionName: 'updateTime',
    match: null,
    order: 'DESC,ASC',
    sort: 'updateTime,state'
  },
  recordListPagination: {
    sort: null,
    order: null,
    size: 20,
    total: 0,
    current: 1,
    layout: 'total, sizes, prev, pager, next, jumper',
    sizes: [10, 20, 30]
  }
}

const mutations = {
  setUiOptions (state, options) {
    for (let key in state.uiOptions) {
      if (options.hasOwnProperty(key)) {
        state.uiOptions[key] = options[key]
      }
    }
  },
  setRecordListPagination (state, pagination) {
    for (let key in state.recordListPagination) {
      if (pagination.hasOwnProperty(key)) {
        state.recordListPagination[key] = pagination[key]
      }
    }
  },
  setRecordListOptions (state, options) {
    for (let key in state.recordListOptions) {
      if (options.hasOwnProperty(key)) {
        state.recordListOptions[key] = options[key]
      }
    }
  },
  setOptions (state, options) {
    for (let key in state.options) {
      if (options.hasOwnProperty(key)) {
        state.options[key] = options[key]
      }
    }
  }
}

const actions = {
  updateRecordListOptions ({commit}, payload) {
    return new Promise(resolve => {
      commit('setRecordListOptions', payload)
      resolve()
    })
  },
  updateRecordListPagination ({commit}, payload) {
    return new Promise(resolve => {
      commit('setRecordListPagination', payload)
      resolve()
    })
  }
}

const getters = {
  recordListPagination (state) {
    return state.recordListPagination
  },
  recordListOptions (state) {
    return state.recordListOptions
  },
  options (state) {
    return state.options
  },
  uiOptions (state) {
    return state.uiOptions
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
